<script>
import { storeCode as getStoreCode } from '@vue-storefront/core/lib/multistore'
import { usercentricsSettingsId } from 'src/modules/vsf-usercentrics/settings-ids'

export default {
  name: 'UsercentricsLoader',
  computed: {
    storeCode () {
      return getStoreCode()
    },
    settingsId () {
      return usercentricsSettingsId(this.storeCode)
    }
  },
  mounted () {
    if (document.getElementById('usercentrics-cmp')) {
      return
    }
    const script = document.createElement('script')
    script.id = 'usercentrics-cmp'
    script.src = 'https://web.cmp.usercentrics.eu/ui/loader.js'
    script.setAttribute('data-settings-id', this.settingsId)
    script.setAttribute('data-tcf-enabled', 'true')
    script.async = true
    document.head.appendChild(script)
  },
  render () {
    return null
  }
}
</script>
